module.exports = __webpack_public_path__ + "ci_vendor_alertnow.3b33a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_alertnow.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_alertnow.svg
// module chunks = main